import { render, staticRenderFns } from "./PendingOrder.vue?vue&type=template&id=0085dd32&scoped=true"
import script from "./PendingOrder.vue?vue&type=script&lang=js"
export * from "./PendingOrder.vue?vue&type=script&lang=js"
import style0 from "./PendingOrder.vue?vue&type=style&index=0&id=0085dd32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0085dd32",
  null
  
)

export default component.exports